import { assign, literal, number, object, string } from "superstruct";

export const RewardsGiftCardRewardSchema = object({
    type: literal("gift_card"),
    initialValue: number(),
});

export const RewardsGiftCardBalanceRewardSchema = assign(
    RewardsGiftCardRewardSchema,
    object({
        code: string(),
        balance: number(),
    })
);
